import { MemberService } from 'src/app/services/member/member.service';
import { Injectable } from '@angular/core';
import { IProductContextCase } from 'src/app/models/case';
import { GetLinkRequestModel } from 'src/app/models/community';
import { Member } from 'src/app/models/member';
import { AuntBerthaEndpoint } from './aunt-bertha.service.endpoint';

@Injectable({
    providedIn: 'root'
})
export class AuntBerthaService {

    constructor(private memberService: MemberService, private endpoint: AuntBerthaEndpoint) { }

    public async getProgramLink(member: Member, currentCase: IProductContextCase): Promise<string> {

        const { memberContext } = this.memberService.getCurrentTelephonyContext();

        const memberData = {
            memberId: member.id,
            memberFirstName: member.firstName,
            memberLastName: member.lastName,
            memberEmailAddress: member.emailAddress,
            memberState: member.primaryAddress && member.primaryAddress.state,
            memberZipCode: member.primaryAddress && member.primaryAddress.postalCode,
            memberPhoneNumber: member.primaryPhone && member.primaryPhone.number,
            caseId: btoa(member.base64TenantId + '|' + memberContext.telephonyRecordId),
            metadata: {
                caseId: currentCase.id,
                tenantId: member.base64TenantId
            }
        } as GetLinkRequestModel;

        return this.endpoint.getProgramLink(memberData).toPromise();
    }
}
